import React from 'react'
import { motion } from 'framer-motion'
import TwoStepProgress from '../modals/TowStepPrgress'
import { GoChevronLeft } from 'react-icons/go'
import IranIcon from '../icons/iranIcon.png'
import inteNational from '../icons/international.png'
import { useState } from 'react'



export default function Step1({ type,setType,shake,currentStep = 1, setCurrentStep = () => {}, onSelectType = () => {}, images = {} }) {
  const { international = '/icon-512.png', domestic = '/icon-512.png' } = images

  const container = {
    hidden: { opacity: 0, y: 8 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        staggerChildren: 0.08,
        when: 'beforeChildren'
      }
    }
  }

  const item = {
    hidden: { opacity: 0, y: 12 },
    show: { opacity: 1, y: 0, transition: { duration: 0.45, ease: 'easeOut' } }
  }



  return (
    <motion.section
      className="flex justify-start items-start flex-col gap-5 max-w-6xl w-full mx-auto"
      variants={container}
      initial="hidden"
      animate="show"
      dir="rtl"
    >

      <motion.div variants={item} className="flex flex-row justify-start w-full h-max">
        <img className="w-[80px] object-contain" src={international} alt="logo" />
      </motion.div>

      <motion.p variants={item} className='block text-gray-400 text-[14px] lg:w-1/2 w-full leading-relaxed'>
        برای شروع نیاز به اطلاعاتی جهت ارائه خدمات بهتر برای ثبت بار به شما داریم. قابل توجه: تضمین حفظ اطلاعات شما با بارسرا می‌باشد.
      </motion.p>

      <motion.div variants={item} className="flex flex-row justify-start items-center gap-5 h-max w-full">
        <div className="h-[40px] w-[10px] rounded-lg bg-special" />
        <p className='text-gray-600 text-[18px]'>نوع باری که قصد دارید در بارسرا ثبت کنید را مشخص کنید</p>
      </motion.div>

      {/* cards grid */}
      <motion.div variants={item} className="grid grid-cols-1 md:flex md:flex-row gap-5 w-full">

        <motion.button
            onClick={
                    (e)=>{
                
                        setType('international')
                    }
          
            }
            animate={{
                scale: type === "international" ? 1.06 : 1,
                boxShadow: type === "international"
                  ? "0 18px 40px rgba(30,58,138,0.18)"   
                  : "0 0px 0px rgba(0,0,0,0)",
                x: shake ? [0, -4, 4, -4, 4, 0] : 0, 
              }}
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.98 }}
            className="group rounded-lg  border-special p-4 flex flex-col items-center gap-4 justify-start lg:w-[300px] w-full hover:shadow-md transition-shadow duration-150"
            aria-label="ثبت بار خارجی"
            >
            <img className='w-full max-w-[220px] h-auto object-contain' src={inteNational} alt="بار خارجی" />
            <p className='text-gray-900 font-medium'>بار خارجی</p>
        </motion.button>

      <motion.button
            onClick={ 
                (e)=>{
                   
                    setType('domestic')
                }
            }
            
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.98 }}
            animate={{
                scale: type === "domestic" ? 1.06 : 1,
                boxShadow: type === "domestic"
                  ? "0 18px 40px rgba(30,58,138,0.18)"   
                  : "0 0px 0px rgba(0,0,0,0)",
                x: shake ? [0, -4, 4, -4, 4, 0] : 0, 
              }}
        
            style={{ zIndex: type === "domestic" ? 20 : 1 }}
            className="group rounded-lg p-4 flex flex-col items-center gap-4 justify-start lg:w-[300px] w-full bg-white cursor-pointer"
            aria-pressed={type === "domestic"}
            aria-label="ثبت بار داخلی"
            >
            <img className='w-full max-w-[220px] h-auto object-contain' src={IranIcon} alt="بار داخلی" />
            <p className='text-gray-900 font-medium'>بار داخلی</p>
        </motion.button>

       



      </motion.div>

   

    </motion.section>
  )
}
